/*
 * @Author: 向上的阳光李子
 * @Date: 2024-07-04 14:30:12
 * @LastEditTime: 2024-08-12 17:23:46
 * @Description: 路由配置页
 * @FastButton: ctrl+win+i, ctrl+win+t
 */
import { createRouter, createWebHistory } from "vue-router";

// 定义路由
// 每个路由应该映射一个组件。
//*=================*感*谢*支*持*正*版*===============*//*
//* *【*原*创*归*属*声*明*】* *//*
//* *本*源*码*唯*一*原*创*作*者*：*闲*鱼*「*向*上*的*阳*光*李*子*」* *//*
//* *官*方*唯*一*售*卖*链*接*：* *//*
//* *【*闲*鱼*】*h*t*t*p*s*:*/*/m*.*t*b*.*c*n*/*h*.*h*D*f*c*L*s*q*?*t*k*=*n*g*q*H*4*N*c*K*C*j*o* *C*Z*1*9*3* *//*
//* *（*点*击*直*接*打*开*，*含*更*多*优*质*源*码*）* *//*
//* *💡* *授*权*说*明*：* *//*
//* *允*许*学*习*/*二*次*开*发*（*二*创*可*售*）*，*严*禁*原*封*不*动*二*次*售*卖* *//*
//* *💰* *价*格*说*明*：* *//*
//* *本*店*源*码* *1*0*-*3*5* *元*，*性*价*比*亲*民*。* *//*
//* *若*遇*盗*版*高*价*，*实*属*遗*憾*；*若*遇*更*低*价*格*，*完*全*理*解*，*望*大*家*拿*到*靠*谱*源*码*。* *//*
//* *📞* *定*制*服*务*：* *//*
//* *W*W*X*X*：*z*h*o*u*l*a*o*b*a*n*0*0* *//*
//* *承*接*各*类*定*制*开*发*，*价*格*公*道*，*童*叟*无*欺* *//*
//* *支*持*：*数*字*孪*生*大*屏*、*t*h*r*e*e*.*j*s*、*C*e*s*i*u*m*、*小*程*序*、*A*P*P* *//*
//* *恳*请*支*持*原*创*，*微*小*改*动*也*是*尊*重* *//*
//* *侵*权*必*究*，*感*谢*理*解*！* *//*
//*=================*承*接*各*类*定*制*开*发*===============*//*
const routes = [
  {
    path: "/",
    redirect: "/wind",
  },

  {
    path: "/wind",
    name: "风电场",
    component: () =>
      import(/* webpackChunkName: "src" */ "@/views/wind/index-page.vue"),
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes: routes,
});

export default router;
